export default "__VITE_ASSET__DmcmaeV7__"